export default "__VITE_ASSET__CP_19Kw6__"